<template>
    <v-bottom-sheet v-model="sheet" scrollable>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon small color="icon" v-bind="attrs" v-on="on">
                <v-icon small>fas fa-camera</v-icon>
            </v-btn>
        </template>
        <!-- LISTA DE TABS VERTICAL -->
        <!-- - AL HACER CLICK EN ICON EYE VER LA IMAGEN EN TAMAÑO GRANDE EN UN MODAL O VIEWER -->
        <!-- - Al hacer click y arrastrar ver la posicion en el index en el que está ubicado. (prueba) -->
        <!-- - IMAGENES MINI -->
        <!-- BOTON DE GUARDAR -->
        <v-sheet class="text-center" height="auto" scrollable style="
              display: flex;
              flex-direction: column;
              gap: 1;
              padding: 2px 12px;
            ">
            <v-btn style="align-self: flex-end" class="" icon @click="sheet = false">
                <v-icon> fas fa-times </v-icon>
            </v-btn>
            <v-card scrollable>
                <v-toolbar flat color="icon" dark>
                    <v-toolbar-title>Gestionar imagenes</v-toolbar-title>
                </v-toolbar>
                <v-tabs :horizontal="isMobile" :vertical="isDesktop" scrollable>
                    <v-tab class="d-flex justify-start">
                        <v-icon left>
                            fas fa-camera
                        </v-icon>
                        Imagenes grandes
                    </v-tab>
                    <v-tab class="d-flex justify-start" scrollable>
                        <v-icon left>
                            fas fa-camera
                        </v-icon>
                        Imagen mini
                    </v-tab>
                    <v-tab-item style="" scrollable>
                        <!-- <v-card flat style="height: 100%;" scrollable> -->
                            <!-- <v-card-text class="" scrollable> -->
                                <ImagenesGrandes :vehiculo="{ vehiculo_id: 1 }" />
                            <!-- </v-card-text> -->
                        <!-- </v-card> -->
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                ACA LAS IMAGENES MINI
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
import ImagenesGrandes from './ImagenesGrandes.vue'

export default {
    data() {
        return {
            sheet: false,
            isMobile: true,
            isDesktop: false
        };
    },
    props: {

    },
    methods: {

    },
    components: {
        ImagenesGrandes
    },
};
</script>
